import React from "react";

import { truncateText } from "../../helpers/truncateText";

import {
  Author,
  CardWrapper,
  Icon,
  Job,
  Name,
  ProfileLink,
  Tag,
  Text,
  Title,
} from "./styles";

import type { Review } from "../../types/reviews"

type ReviewCardProps = {
  review: Review;
  categoryTitle?: string;
  onClick?: () => void;
  isReviewsPage?: boolean;
};

export const ReviewCard: React.FC<ReviewCardProps> = ({
  review,
  categoryTitle = "Без категории",
  onClick,
  isReviewsPage,
}) => {
  return (
    <CardWrapper onClick={onClick} $isReviewsPage={isReviewsPage}>
      <Tag>{categoryTitle}</Tag>
      <Title>{review.product?.title || "Без названия"}</Title>
      <Text>{truncateText(review.content, 350)}</Text>
      <Author>
        <Name>{review.author}{review.job_title && ", "}</Name>
        <Job>&nbsp;{review.job_title}</Job>
      </Author>
      {review.profile_url && (
        <ProfileLink
          href={review.profile_url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
        >
                    Профиль LinkedIn
          <Icon />
        </ProfileLink>
      )}
    </CardWrapper>
  );
};
